// apps/web/src/features/road-options/queries.ts
//
// Query-key constant for the Roads admin catalog (#1152). Mirrors
// `ARRIVAL_CITIES_QK = ['arrival-cities-catalog']`. Mutations on
// `/road-options` must invalidate BOTH this catalog key AND
// `ROAD_OPTIONS_ACTIVE_QK` from
// `apps/web/src/features/requests/dictionarySelections.queries.ts`
// so the request-form picker reflects new values without a reload.
//
// User-cache reset: this key is wiped in
// `apps/web/src/auth/userCacheReset.ts` per the `@aiInvariant` block
// for permission-gated reference catalogs.

export const ROAD_OPTIONS_CATALOG_QK = ['road-options-catalog'] as const;
